export default class dataList {
    static homePage() {
        return {
            title: 'JORNAY PM (methylphenidate HCI) for ADHD Treatment',
            /*titleTemplate: '%s | HCP Site',*/
            meta: [
                {
                    name: 'description', content: 'Learn about JORNAY PM (methylphenidate HCI), the first and only evening-dosed methylphenidate treatment that provides all-day ADHD symptom control. See Boxed Warning, Safety Info., and full Prescribing Information.'
                }
            ]
        }
    }

    // PK Data
    static pkPage() {
        return {
            title: 'Explore the PK Data for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'See the PK data for JORNAY PM (methylphenidate HCI), to learn more about how long it lasts and the onset and offset of effect. See Full Prescribing & Safety Info.'
                }
            ]
        }
    }

    // PK/PD Model
    static doseDependentPage() {
        return {
            title: 'Dosage & Duration of Action for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Learn about dose-dependent duration with JORNAY PM (methylphenidate HCI), which allows all-day ADHD symptom control with one dose. See Full Prescribing & Safety Info.'
                }
            ]
        }
    }

    static dosingPage() {
        return {
            title: 'Explore Dosing Info for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'JORNAY PM is the first & only evening-dosed medication that gives the flexibility of 5 dosage strengths to adjust the duration of ADHD symptom control. See Full Prescribing & Safety Info.'
                }
            ]
        }
    }

    static efficacyPage() {
        return {
            title: 'Explore Uses & Efficacy for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Learn about the efficacy and safety of JORNAY PM (methylphenidate HCI) that provides all-day ADHD symptom control. Read the clinical data. See Full Prescribing & Safety Info.'
                }
            ]
        }
    }

    static safetyPage() {
        return {
            title: 'Learn Safety & Side Effects of JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Read the safety profile for JORNAY PM (methylphenidate hydrochloride) to learn more about the side effects. See Boxed Warning, Safety Info., and full Prescribing Information.'
                }
            ]
        }
    }

    static savingsPage() {
        return {
            title: 'Learn About Cost & Savings | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Find cost, savings options, and insurance resources, including Medicaid coverage, for Jornay PM (methylphenidate HCI). See Boxed Warning, Safety Info., and full Prescribing Information.'
                }
            ]
        }
    }

    static resourcesPage() {
        return {
            title: 'ADHD Patient Resources | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Download resources for your ADHD patients to help them get started on JORNAY PM (methylphenidate hydrochloride). See Boxed Warning, Safety Info., and full Prescribing Information.'
                }
            ]
        }
    }

    static thankYouPage() {
        return {
            title: 'Thank You',
            titleTemplate: '%s | JORNAY PM (methylphenidate hydrochloride)',
            meta: [
                {
                    name: 'description', content: 'We appreciate your interest in JORNAY PM and\n' +
                        'will honor your request for a visit with a\n' +
                        'representative and/or your request to receive\n' +
                        'email updates.'
                }
            ]
        }
    }

    static peerspectivesPage() {
        return {
            title: 'Explore PeerSpectives Videos | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Find informational video resources about Jornay PM (methylphenidate HCI) from physicians, specialists, and patients. See Boxed Warning for full prescribing & safety info.'
                }
            ]
        }
    }

    static pricePage() {
        return {
            title: 'Price Information | JORNAY PM (methylphenidate hydrochloride)',
            meta: [
                {
                    name: 'description', content: 'Find JORNAY PM (methylphenidate hydrochloride) pricing information. Visit Jornaypm-pro.com for more information.'
                }
            ]
        }
    }

    static signUpPage() {
        return {
            title: 'Request More Information | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Sign up to receive more information on JORNAY PM (methylphenidate HCI) and how to get your patients started. See Boxed Warning, Safety Info., and full Prescribing Information.'
                }
            ]
        }
    }


}
